<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span>แบบฟอร์ม บริการ</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <v-row class="flex-column">
                <center>
                  <v-avatar
                    v-if="image"
                    size="120"
                    tile
                    @click="$refs.serviceImageInput.click()"
                  >
                    <img
                      :src="image"
                      alt="serviceImage"
                    >
                  </v-avatar>
                  <v-avatar
                    v-else
                    ref="serviceImage"
                    size="120"
                    color="orange"
                    tile
                    class="mb-3"
                    @click="$refs.serviceImageInput.click()"
                  >
                    <v-icon size="48">
                      fas fa-id-card-alt
                    </v-icon>
                  </v-avatar>
                  <input
                    ref="serviceImageInput"
                    type="file"
                    style="display: none;"
                    accept="image/png, image/jpeg, image/jpg"
                    @input="readFile"
                  >
                  <span
                    v-if="$v.file.$dirty && !$v.file.imageValidator"
                    class="red--text text-ex-center"
                  >
                    {{ imageErrors[0] }}
                  </span>
                </center>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              md="9"
            >
              <v-row no-gutters>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="name"
                    :error-messages="nameErrors"
                    label="ชื่อบริการ"
                    filled
                    class="pr-1"
                    color="orange"
                    @input="$v.name.$touch()"
                    @blur="$v.name.$touch()"
                  />
                </v-col>
                <v-col
                  md="6"
                  cols="12"
                >
                  <v-text-field
                    v-model="time"
                    :error-messages="timeErrors"
                    label="เวลา[นาที]"
                    filled
                    class="pr-1"
                    color="orange"
                    @input="$v.time.$touch()"
                    @blur="$v.time.$touch()"
                  />
                </v-col>
                <v-col
                  md="6"
                  cols="12"
                >
                  <v-text-field
                    v-model="price"
                    :error-messages="priceErrors"
                    label="ราคา"
                    filled
                    class="pr-1"
                    color="orange"
                    @input="$v.price.$touch()"
                    @blur="$v.price.$touch()"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-textarea
                    v-model="description"
                    :error-messages="descriptionErrors"
                    label="รายละเอียด"
                    filled
                    color="orange"
                    counter="255"
                    @input="$v.description.$touch()"
                    @blur="$v.description.$touch()"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="orange"
            text
            @click="submit()"
          >
            <v-icon
              left
              small
            >
              fas fa-save
            </v-icon>
            Save
          </v-btn>
          <v-btn
            color="red"
            text
            @click="$emit('closeDialog')"
          >
            <v-icon
              left
              small
            >
              fas fa-times
            </v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  required,
  maxLength,
  minLength,
  integer,
} from 'vuelidate/lib/validators';
import imageValidator from '@/utils/imageValidator';

export default {
  name: 'ServiceForm',
  validations: {
    name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(255),
    },
    price: {
      required,
      integer,
    },
    time: {
      required,
      integer,
    },
    description: {
      maxLength: maxLength(255),
    },
    file: {
      imageValidator,
    },
  },
  props: {
    formDialog: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
      name: '',
      price: '',
      time: '',
      description: '',
      image: '',
      file: '',
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.required) {
        errors.push('กรุณากรอกชื่อบริการ');
      }
      return errors;
    },
    priceErrors() {
      const errors = [];
      if (!this.$v.price.$dirty) return errors;
      if (!this.$v.price.required) {
        errors.push('กรุณาราคาบริการ');
      }
      if (!this.$v.price.integer) {
        errors.push('ราคาต้องเป็นตัวเลขเท่านั้น');
      }
      return errors;
    },
    timeErrors() {
      const errors = [];
      if (!this.$v.time.$dirty) return errors;
      if (!this.$v.time.required) {
        errors.push('กรุณากรอกเวลาที่ใช้ในการบริการ');
      }
      if (!this.$v.time.integer) {
        errors.push('เวลาต้องเป็นตัวเลขเท่านั้น');
      }
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.description.$dirty) return errors;
      if (!this.$v.description.maxLength) {
        errors.push('รายละเอียดต้องไม่เกิน 255 ตัวอีกษร');
      }
      return errors;
    },
    imageErrors() {
      const errors = [];
      if (!this.$v.file.$dirty) return errors;
      if (!this.$v.file.imageValidator) {
        errors.push('ขนาดไฟล์ต้องไม่เกิน 5 mb');
      }
      return errors;
    },
  },
  watch: {
    formDialog(value) {
      this.dialog = value;
    },
    formData(value) {
      if (value) {
        this.name = value.name;
        this.price = value.price;
        this.time = value.time;
        this.description = value.description;
        this.image = value.image;
      }
    },
  },
  methods: {
    readFile(event) {
      const input = event.target;
      if (input.files[0]) {
        this.$v.file.$touch();
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.image = ev.target.result;
        };
        // eslint-disable-next-line
        this.file = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const data = {
          name: this.name,
          price: this.price,
          time: this.time,
          description: this.description,
        };
        if (this.file) {
          data.image = this.file;
        }
        this.$emit('submitForm', data);
        this.$v.$reset();
      }
    },
  },
};
</script>
